export const ROLES = {
    admin: 19,
    operator: 20,
    customer: 21,
    externalSupport: 22,
    fraudPrevention: 23,
    fraudPreventionAdmin: 24,
    userAdmin: 25,
};

export const ROLES_TEXT = {
    'admin.natura': 'Administrador',
    'operador.natura': 'Operador',
    'ext-support-operator.natura': 'Externo de Soporte',
    'fraud_prevention_admin.natura': 'Administrador de Prevención de Fraude',
    'user_admin.natura': 'Administrador de Usuarios',
};

export const ROLE_STRING_TO_ID = {
    'admin.natura': ROLES.admin,
    'operator.natura': ROLES.operator,
    'operador.natura': ROLES.operator,
    'customer.natura': ROLES.customer,
    'ext-support-operator.natura': ROLES.externalSupport,
    'fraud_prevention_analyst.natura': ROLES.fraudPrevention,
    'fraud_prevention_admin.natura': ROLES.fraudPreventionAdmin,
    'user_admin.natura': ROLES.userAdmin,
};

const ACCESSIBLE_ADMIN = [
    ROLES.admin,
];

const ACCESSIBLE_ALL = [
    ROLES.admin,
    ROLES.operator,
    ROLES.externalSupport,
];
const ACCESSIBLE_INTERNAL = [
    ROLES.admin,
    ROLES.operator,
];
const ACCESSIBLE_EXTERNAL = [
    ROLES.externalSupport,
];
const ACCESSIBLE_FRAUD_PREVENTION = [
    ROLES.fraudPrevention,
    ROLES.fraudPreventionAdmin,
];

export const ACCESS = {
    ADMIN: ACCESSIBLE_ADMIN,
    ALL: ACCESSIBLE_ALL,
    INTERNAL: ACCESSIBLE_INTERNAL,
    EXTERNAL: ACCESSIBLE_EXTERNAL,
    FRAUD_PREVENTION: ACCESSIBLE_FRAUD_PREVENTION,
};

export const ALLOWED_ROLES = [ROLES.admin, ROLES.operator, ROLES.externalSupport, ROLES.fraudPrevention, ROLES.fraudPreventionAdmin, ROLES.userAdmin];

export const hasRole = (user, roleId) => {
    return user?.roles?.some(userRole => userRole.role.id === roleId);
};
